exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#div-padlock[data-v-5b6ee1c0]{\n    text-align: center;\n    padding : 15px;\n    padding-bottom: 90px;\n}\n.width-100prc[data-v-5b6ee1c0]{\n    width: 100%;\n}\n", ""]);

// exports
